import { useEffect, useState } from "react";
import CardCourses from "./layout/CardCourses";
import LoadingData from "../Common/LoadingData";


const MyCourses = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/myprofile`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setData(data.msg);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : data?.inprogress.length > 0 || data?.completed.length > 0 ? (
    <div className="my-courses-page">
      <div className="container">
        <div className="row">
          <div className="col-md-11 m-auto">
            <div className="my-courses-header">
              <div className="row">
                <div className="col-md-9 m-auto">
                  <h2 className="my-courses-title">My Courses</h2>
                </div>
              </div>
            </div>
            <div className="my-courses-content">
              <div className="my-courses-content-item">
                <div className="row">
                  <div className="col-md-9 m-auto">
                    <h4>InProgress</h4>
                    <div className="my-courses-content-item-list">
                      <CardCourses />
                    </div>
                  </div>
                </div>
              </div>
              <div className="my-courses-content-item">
                <div className="row">
                  <div className="col-md-9 m-auto">
                    <div className="title-completed">
                      <h4>Completed</h4>
                      <i className="fas fa-check-circle"></i>
                    </div>
                    <div className="my-courses-content-item-list">
                      <CardCourses />
                      <CardCourses />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div style={{ marginTop: "200px" }}>
      <LoadingData />
    </div>
  );
};

export default MyCourses;
